import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Sport } from '__generated__/globalTypes';
import { useMonetaryAmount } from 'hooks/useMonetaryAmount';

import type {
  ReferralProgramConfigQuery,
  ReferralProgramConfigQueryVariables,
} from './__generated__/useReferralProgramConfig.graphql';
import { useQuery } from './graphql/useQuery';

const REFERRAL_PROGRAM_CONFIG_QUERY = gql`
  query ReferralProgramConfigQuery($sport: Sport) {
    config {
      id
      referralProgramConfig(sport: $sport) {
        id
        maxDiscount {
          ...useMonetaryAmount_monetaryAmount
        }
      }
    }
  }
  ${useMonetaryAmount.fragments.monetaryAmount}
` as TypedDocumentNode<
  ReferralProgramConfigQuery,
  ReferralProgramConfigQueryVariables
>;

export const useReferralProgramConfig = (sport: Sport) => {
  const { data } = useQuery(REFERRAL_PROGRAM_CONFIG_QUERY, {
    variables: { sport },
  });
  const { referralProgramConfig } = data?.config || {};
  const { toMonetaryAmount, getUserFiatAmountInMajorUnit } =
    useMonetaryAmount();

  return {
    referralProgramConfig,
    userFiatAmount: referralProgramConfig
      ? getUserFiatAmountInMajorUnit(
          toMonetaryAmount(referralProgramConfig.maxDiscount)
        )
      : undefined,
  };
};
